import {
  RiDashboardLine,
  RiFolderOpenLine,
  RiUserLine,
  RiBuildingLine,
  RiGroupLine,
  RiListCheck,
  RiTimeLine,
  RiFileChartLine,
  RiSettingsLine,
  RiMoneyDollarCircleLine,
  RiFileSettingsLine,
  RiFileDownloadLine,
  RiListSettingsLine,
} from "react-icons/ri";
import { ROUTES } from "../constants";
import {
  PERMISSION_KEYS,
  TIME_ENTRY_TAB_VIEW_KEYS,
  SETTINGS_SYSTEM_LISTS_ANY_KEYS,
  WORK_ITEMS_SIDEBAR_ANY_KEYS,
} from "../permissions/permissionKeys";

export const menuItems = [
  {
    id: 1,
    title: "Dashboard",
    path: "/dashboard",
    icon: RiDashboardLine,
    activePath: "dashboard",
    hasSubmenu: false,
    sidebarPermission: PERMISSION_KEYS.DASHBOARD_VIEW,
  },
  {
    id: 4,
    title: "Clients",
    path: "/clients",
    icon: RiBuildingLine,
    activePath: "clients",
    hasSubmenu: false,
    sidebarPermission: PERMISSION_KEYS.CLIENTS_SIDEBAR,
  },
  {
    id: 2,
    title: "Projects",
    path: "/projects",
    icon: RiFolderOpenLine,
    activePath: "projects",
    hasSubmenu: false,
    sidebarPermission: PERMISSION_KEYS.PROJECTS_SIDEBAR,
  },
  {
    id: 5,
    title: "Work Items",
    path: "/issues",
    icon: RiListCheck,
    activePath: "issues",
    hasSubmenu: false,
    sidebarPermission: [...WORK_ITEMS_SIDEBAR_ANY_KEYS],
  },
  {
    id: 9,
    title: "Time Entry",
    path: "/time-entry",
    icon: RiTimeLine,
    activePath: "time-entry",
    hasSubmenu: false,
    /** Same gate as `/time-entry` route — any tab view permission. */
    sidebarPermission: [...TIME_ENTRY_TAB_VIEW_KEYS],
  },
  {
    id: 12,
    title: "Billing",
    icon: RiMoneyDollarCircleLine,
    activePath: "billing",
    hasSubmenu: true,
    submenuItems: [
      {
        id: 12.1,
        title: "SaaS Export",
        path: "/billing/saas-billing",
        icon: RiMoneyDollarCircleLine,
        activePath: "billing",
        sidebarPermission: PERMISSION_KEYS.SAAS_BILLING_VIEW,
      },
      {
        id: 12.2,
        title: "QB Export",
        path: "/billing/exports",
        icon: RiFileDownloadLine,
        activePath: "billing",
        sidebarPermission: PERMISSION_KEYS.QB_BILLING_VIEW,
      },
      {
        id: 12.3,
        title: "Month Locking & Audit",
        path: "/reports",
        icon: RiFileChartLine,
        activePath: "reports",
        sidebarPermission: PERMISSION_KEYS.REPORTS_LOCK_AUDIT_VIEW,
      },
    ],
  },
  {
    id: 3,
    title: "Users",
    path: "/users",
    icon: RiUserLine,
    activePath: "users",
    hasSubmenu: false,
    sidebarPermission: PERMISSION_KEYS.USERS_VIEW,
  },
  {
    id: 6,
    title: "Teams",
    path: "/teams",
    icon: RiGroupLine,
    activePath: "teams",
    hasSubmenu: false,
    sidebarPermission: PERMISSION_KEYS.TEAMS_VIEW,
  },
  {
    id: 11,
    title: "Settings",
    icon: RiSettingsLine,
    activePath: "settings",
    hasSubmenu: true,
    submenuItems: [
      {
        id: 11.3,
        title: "Role & Permission",
        path: "/settings/role-permission",
        icon: RiFileSettingsLine,
        activePath: "settings",
        sidebarPermission: PERMISSION_KEYS.SETTINGS_ROLE_PERMISSION,
      },
      {
        id: 11.4,
        title: "System lists",
        path: ROUTES.SETTINGS_SYSTEM_LISTS,
        icon: RiListSettingsLine,
        activePath: "settings",
        sidebarPermission: [...SETTINGS_SYSTEM_LISTS_ANY_KEYS],
      },
    ],
  },
];
